import { RANDOM_CHAR_POOL, randomString } from "./randomString";

const queryName = "eid";
const idLength = 32;

export default function useEventId() {
  const searchParams = new URLSearchParams(window.location.search);
  const eventId = searchParams.get(queryName) || "";
  if (!checkEventId(eventId)) {
    const newEventId = randomString(idLength);
    searchParams.set(queryName, newEventId);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
    return newEventId;
  }
  return eventId;
}

function checkEventId(id: string) {
  const regex = new RegExp(`^[${RANDOM_CHAR_POOL}]{${idLength}}$`);
  return regex.test(id);
}
